// eslint-disable no-param-reassign

import Drawer from './Drawer'
import { icons } from './icons'

export default class DrawerManager {
	drawers = []
	destroys = []
	overlay = undefined
	accountIcon = undefined
	inactive = true

	constructor() {
		// Get all drawers from the DOM
		const drawers = Array.from(document.querySelectorAll('[data-drawer-name]'))

		// Set icon
		const icon = document.querySelector('#account-chevron')
		icon ? (this.accountIcon = icon) : null

		// Get drawer overlay from the DOM
		const overlay = document.querySelector('[data-drawer-overlay]')

		// Add them to DrawerManager class instance
		drawers.forEach(drawer => {
			this.drawers.push(
				new Drawer({
					name: drawer.dataset.drawerName,
					ref: drawer,
					icons: {
						active: drawer.dataset.iconActive,
						inactive: drawer.dataset.iconInactive,
					},
					animations: {
						in: drawer.dataset.animateIn,
						out: drawer.dataset.animateOut,
					},
					handleTrigger: this.handleTrigger.bind(this),
				}),
			)
		})

		if (overlay) {
			this.overlay = overlay

			this.overlay.addEventListener('click', () => {
				this.closeAll()
			})
		}
	}

	close = name => {
		const drawerToClose = this.drawers.find(d => d._name === name)
		const drawerName = drawerToClose._name

		drawerToClose.close(drawerName)
	}

	cleanup = () => {
		if (this.destroys && this.destroys.length > 0) {
			this.destroys.forEach(d => {
				if (d instanceof HTMLElement) {
					d.style.transition = 'all .23s ease'
					d.style.opacity = 0

					setTimeout(() => {
						d.remove()
					}, 230)
				}
			})
		}
	}

	open = name => {
		this.inactive = false
		this.cleanup()

		if (this.overlay?.classList.contains('hidden')) {
			this.overlay?.classList.remove('hidden')
		}

		if (this.overlay.classList.contains('fade-out')) {
			this.overlay.classList.toggle('fade-out', false)
		}

		if (!this.overlay?.classList.contains('fade-in')) {
			this.overlay?.classList.add('fade-in', true)
		}

		const drawerToOpen = this.drawers.find(d => d._name === name)
		const drawerName = drawerToOpen._name

		drawerToOpen.open(drawerName)

		if (drawerToOpen._name !== 'menu') {
			setTimeout(() => {
				const renderedDrawerHeight = drawerToOpen._ref.clientHeight

				if (renderedDrawerHeight % 2 !== 0) {
					const newHeight = renderedDrawerHeight + 1

					drawerToOpen._ref.style.height = `${newHeight}px`
				}
			}, 280)
		}
	}

	resetIcons = drawer => {
		// Set icons
		const togglers = document.querySelectorAll(`[data-drawer-toggle="${drawer._name}"]`)

		togglers.forEach(el => {
			const { drawerIconActive: icon = '' } = el.dataset

			if (icon) {
				const elements = Array.from(
					document.querySelectorAll(`[data-drawer-icon-active="${icon}"]`),
				)
				const pathHtml = icons[icon]
				const hasElements = elements && elements.length > 0

				if (pathHtml && hasElements) {
					elements.forEach(element => {
						const svg = element.querySelector('svg')
						svg.innerHTML = pathHtml
					})
				}
			}
		})
	}

	closeAllExcept = name => {
		this.drawers
			.filter(d => d._name !== name)
			.forEach(d => {
				// Close drawer
				d.close()

				this.resetIcons(d)
			})
	}

	closeAccessories = () => {
		const accessoriesDrawer = document.querySelector('.accessories-drawer')

		if (accessoriesDrawer) {
			accessoriesDrawer.classList.toggle('fade-in-right', false)
			accessoriesDrawer.classList.toggle('fade-out-right', true)
		}
	}

	closeAll = () => {
		this.overlay.classList.remove('fade-in')
		this.overlay.classList.add('fade-out')

		if (this.accountIcon && this.accountIcon instanceof HTMLElement) {
			this.accountIcon.style.transform = 'rotateZ(0deg)'
		}

		this.drawers.map(d => d.close())
		this.closeAccessories()
		this.inactive = true
	}

	hasDrawer(name) {
		return this.drawers.some(d => d._name === name)
	}

	addDrawer({ name, ref, animations }) {
		if (this.hasDrawer(name)) return

		this.drawers.push(
			new Drawer({
				name,
				ref,
				animations: {
					in: animations.in,
					out: animations.out,
				},
				toggleOverlay: this.toggleOverlay,
				closeAllExcept: this.closeAllExcept,
				closeAll: this.closeAll,
			}),
		)
	}

	removeDrawer(name) {
		this.drawers = this.drawers.filter(d => d._name !== name)
	}

	toggleOverlay(forced = false) {
		if (this.drawers.some(x => x._visible === true || forced)) {
			this.overlay.classList.toggle('hidden', false)
			this.overlay.classList.toggle('fade-in', true)
			this.overlay.classList.toggle('fade-out', false)
		} else {
			this.overlay.classList.toggle('fade-out', true)
			this.overlay.classList.toggle('fade-in', false)
		}
	}

	handleTrigger({ name, visible, icon }) {
		this.cleanup()

		// Close all or all except one?
		!visible ? this.closeAll() : this.closeAllExcept(name)

		// Always toggle overlay
		this.toggleOverlay()

		// Set correct icons
		if (icon) {
			const elements = Array.from(
				document.querySelectorAll(`[data-drawer-icon-inactive="${icon}"]`),
			)
			const pathHtml = icons[icon]
			const hasElements = elements && elements.length > 0

			if (pathHtml && hasElements) {
				elements.forEach(element => {
					const svg = element.querySelector('svg')
					svg.innerHTML = pathHtml
				})
			}
		}
	}
}
